import {default as React, useState} from "react";
import {Modal, ModalBody, ModalHeader} from 'reactstrap';
import {CardObject} from "../../../types.d";
import {TopicModal} from "./TopicModal";
import {Link} from "react-router-dom";

interface ExplanationModalProps {
    notEditable?: boolean;
    card: CardObject;
    visible: boolean;
    toggle: () => any;
}

export const ExplanationModal = (props: ExplanationModalProps) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { card } = props;

    return <Modal isOpen={props.visible}
                  className={'large-modal'}
                  toggle={props.toggle}>
        <ModalHeader toggle={props.toggle}>{ card.postTitle }</ModalHeader>
        <ModalBody>
            <div dangerouslySetInnerHTML={{
                __html: card.explanationRules
            }} />
        </ModalBody>

        <div className="d-flex justify-content-between card-footer">
            { !props.notEditable && (
                <Link to={`/courses/${card.course.id}/topic/${card.topic.id}/explanations/${card.id}`} className="btn btn-sm btn-primary" onClick={e => {
                    props.toggle();
                }}>Edit</Link>
            ) }

            <div>
                <h6 className="mt-1">
                    <a href="" onClick={e => {
                        e.preventDefault();

                        setModalVisible(true);
                    }}>Show Topic</a>
                </h6>
            </div>
        </div>

        <TopicModal card={card} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
    </Modal>
};
